<template>
  <v-container :class="`pb-5 ${$vuetify.breakpoint.mdAndUp ? 'pt-12': '' }`">
    <v-row>
      <v-col cols="12" md="8" offset-md="2"
             class="text-center">
        <h1>Coming Soon - finBroker!</h1>
        <p :class="`mt-6 ${$vuetify.breakpoint.mdAndUp ? 'mb-12': 'mb-2' }`">
          Wir sind gerade dabei den finBroker für dich zu bauen, denn wir wollen dir alles aus einer Hand liefern. So
          kannst du demnächst dein Musterportfolio direkt in ein reales Depot umwandeln und Wertpapiere kaufen und
          verkaufen. Bis dahin kannst du dir dein Portfolio als Excel herunterladen und als Order-Vorlage aus der
          Portfolio Detailansicht heraus generieren.
        </p>
        <v-img :src="require('@/assets/brokerage/finCraft_Broker_Illustration-17.png')"
               contain
               :width="$vuetify.breakpoint.xs ? 320: 500"
               class="mx-auto"/>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>

export default {
  name: "FinComingFeatures",
}
</script>

<style lang="scss" scoped>

</style>
